import { RESET_STORE } from '../generalTypes'
// eslint-disable-next-line import/no-cycle
import {
	IQueuesPayload,
	IFormTemplatePayload,
	IDatabasesPayload,
	IProceduresPayload,
	IColumnsPayload,
	IElementsPayload,
	ITabsPayload,
	IConfigsPayload,
	IFormItemsPayload,
	IPlaceholderSize
} from './formActions'
// eslint-disable-next-line import/no-cycle
import { IFormItemData, ILoadingAndFailure } from '../../types/interfaces'
import {
	FORM_TEMPLATE_QUEUES,
	FORM_TEMPLATE,
	FORM_EDIT_CHANGE,
	FORM_EDITED,
	RESET_FORM_STORE,
	FORM_TEMPLATE_DATABASES,
	FORM_TEMPLATE_PROCEDURES,
	FORM_TEMPLATE_COLUMNS,
	LOAD,
	FORM_TEMPLATE_ELEMENTS,
	FORM_TEMPLATE_TABS,
	FORM_TEMPLATE_CONFIGS,
	FORM_TEMPLATE_ITEM_COPY,
	FORM_PLACEHOLDER,
	FORM_TABLE_ITEMS
} from './formTypes'

export const initState = {
	queue: {
		data: null,
		isLoading: false,
		isFailure: false
	} as IQueuesPayload & ILoadingAndFailure,
	databases: {
		data: null,
		isLoading: false,
		isFailure: false
	} as IDatabasesPayload & ILoadingAndFailure,
	procedures: {
		data: null,
		isLoading: false,
		isFailure: false
	} as IProceduresPayload & ILoadingAndFailure,
	formTemplate: {
		data: null,
		isLoading: false,
		isFailure: false
	} as IFormTemplatePayload & ILoadingAndFailure,
	columns: {
		data: null,
		isLoading: false,
		isFailure: false
	} as IColumnsPayload & ILoadingAndFailure,
	tabs: {
		data: null,
		isLoading: false,
		isFailure: false
	} as ITabsPayload & ILoadingAndFailure,
	validableComponents: {
		data: null,
		isLoading: false,
		isFailure: false
	} as IElementsPayload & ILoadingAndFailure,
	configs: {
		data: null,
		isLoading: false,
		isFailure: false
	} as IConfigsPayload & ILoadingAndFailure,
	formTableItems: {
		data: null,
		isLoading: false,
		isFailure: false
	} as IFormItemsPayload & ILoadingAndFailure,
	disable: false,
	formEdited: false,
	load: false,
	formItemCopy: null as IFormItemData | null,
	placeholder: {
		height: null,
		width: null
	} as IPlaceholderSize
}

export default (state = initState, action: any) => {
	switch (action.type) {
		case FORM_TEMPLATE_QUEUES.FORM_TEMPLATE_QUEUES_LOAD_START:
			return {
				...state,
				queue: {
					...state.queue,
					isFailure: false,
					isLoading: true
				}
			}
		case FORM_TEMPLATE_QUEUES.FORM_TEMPLATE_QUEUES_LOAD_FAIL:
			return {
				...state,
				queue: {
					...initState.queue,
					isFailure: true
				}
			}
		case FORM_TEMPLATE_QUEUES.FORM_TEMPLATE_QUEUES_LOAD_DONE:
			return {
				...state,
				queue: {
					...initState.queue,
					data: action.payload.data
				}
			}
		case FORM_TEMPLATE_CONFIGS.FORM_TEMPLATE_CONFIGS_LOAD_START:
			return {
				...state,
				configs: {
					...state.configs,
					isFailure: false,
					isLoading: true
				}
			}
		case FORM_TEMPLATE_CONFIGS.FORM_TEMPLATE_CONFIGS_LOAD_FAIL:
			return {
				...state,
				configs: {
					...initState.configs,
					isFailure: true
				}
			}
		case FORM_TEMPLATE_CONFIGS.FORM_TEMPLATE_CONFIGS_LOAD_DONE:
			return {
				...state,
				configs: {
					...initState.configs,
					data: action.payload.data
				}
			}
		case FORM_TEMPLATE_TABS.FORM_TEMPLATE_TABS_LOAD_START:
			return {
				...state,
				tabs: {
					...state.tabs,
					isFailure: false,
					isLoading: true
				}
			}
		case FORM_TEMPLATE_TABS.FORM_TEMPLATE_TABS_LOAD_FAIL:
			return {
				...state,
				tabs: {
					...initState.tabs,
					isFailure: true
				}
			}
		case FORM_TEMPLATE_TABS.FORM_TEMPLATE_TABS_LOAD_DONE:
			return {
				...state,
				tabs: {
					...initState.tabs,
					data: action.payload.data
				}
			}
		case FORM_TEMPLATE_DATABASES.FORM_TEMPLATE_DATABASES_LOAD_START:
			return {
				...state,
				databases: {
					...state.databases,
					isFailure: false,
					isLoading: true
				}
			}
		case FORM_TEMPLATE_DATABASES.FORM_TEMPLATE_DATABASES_LOAD_FAIL:
			return {
				...state,
				databases: {
					...initState.databases,
					isFailure: true
				}
			}
		case FORM_TEMPLATE_DATABASES.FORM_TEMPLATE_DATABASES_LOAD_DONE:
			return {
				...state,
				databases: {
					...initState.databases,
					data: action.payload.data
				}
			}
		case FORM_TEMPLATE_PROCEDURES.FORM_TEMPLATE_PROCEDURES_LOAD_START:
			return {
				...state,
				procedures: {
					...state.procedures,
					isFailure: false,
					isLoading: true
				}
			}
		case FORM_TEMPLATE_PROCEDURES.FORM_TEMPLATE_PROCEDURES_LOAD_FAIL:
			return {
				...state,
				procedures: {
					...initState.procedures,
					isFailure: true
				}
			}
		case FORM_TEMPLATE_PROCEDURES.FORM_TEMPLATE_PROCEDURES_LOAD_DONE:
			return {
				...state,
				procedures: {
					...initState.procedures,
					data: action.payload.data
				}
			}
		case FORM_TEMPLATE.FORM_TEMPLATE_LOAD_START:
			return {
				...state,
				formTemplate: {
					...state.formTemplate,
					isFailure: false,
					isLoading: true
				}
			}
		case FORM_TEMPLATE.FORM_TEMPLATE_LOAD_FAIL:
			return {
				...state,
				formTemplate: {
					...initState.formTemplate,
					isFailure: true
				}
			}
		case FORM_TABLE_ITEMS.FORM_TABLE_ITEMS_LOAD_START:
			return {
				...state,
				formTableItems: {
					...state.formTableItems,
					isFailure: false,
					isLoading: true
				}
			}
		case FORM_TABLE_ITEMS.FORM_TABLE_ITEMS_LOAD_FAIL:
			return {
				...state,
				formTableItems: {
					...initState.formTableItems,
					isFailure: true
				}
			}
		case FORM_TABLE_ITEMS.FORM_TABLE_ITEMS_LOAD_DONE:
			return {
				...state,
				formTableItems: {
					...initState.formTableItems,
					data: action.payload.data
				}
			}
		case FORM_TEMPLATE.FORM_TEMPLATE_CHANGE_BACKUP_STATUS:
			return {
				...state,
				formTemplate: {
					...state.formTemplate,
					data: {
						...state.formTemplate.data,
						backup: {
							...state.formTemplate.data?.backup,
							status: action.status
						}
					}
				}
			}
		case FORM_TEMPLATE.FORM_TEMPLATE_LOAD_DONE:
			return {
				...state,
				formTemplate: {
					...initState.formTemplate,
					data: action.payload.data
				}
			}
		case FORM_TEMPLATE_COLUMNS.FORM_TEMPLATE_COLUMNS_LOAD_START:
			return {
				...state,
				columns: {
					...state.columns,
					isFailure: false,
					isLoading: true
				}
			}
		case FORM_TEMPLATE_COLUMNS.FORM_TEMPLATE_COLUMNS_LOAD_FAIL:
			return {
				...state,
				columns: {
					...initState.columns,
					isFailure: true
				}
			}
		case FORM_TEMPLATE_COLUMNS.FORM_TEMPLATE_COLUMNS_LOAD_DONE:
			return {
				...state,
				columns: {
					...initState.columns,
					data: action.payload.data
				}
			}
		case FORM_TEMPLATE_ELEMENTS.FORM_TEMPLATE_ELEMENTS_LOAD_START:
			return {
				...state,
				validableComponents: {
					...state.validableComponents,
					isFailure: false,
					isLoading: true
				}
			}
		case FORM_TEMPLATE_ELEMENTS.FORM_TEMPLATE_ELEMENTS_LOAD_FAIL:
			return {
				...state,
				validableComponents: {
					...initState.validableComponents,
					isFailure: true
				}
			}
		case FORM_TEMPLATE_ELEMENTS.FORM_TEMPLATE_ELEMENTS_LOAD_DONE:
			return {
				...state,
				validableComponents: {
					...initState.validableComponents,
					data: action.payload.data
				}
			}
		case FORM_PLACEHOLDER.FORM_PLACEHOLDER_HEIGHT:
			return {
				...state,
				placeholder: {
					...state.placeholder,
					height: action.data
				}
			}
		case FORM_PLACEHOLDER.FORM_PLACEHOLDER_WIDTH:
			return {
				...state,
				placeholder: {
					...state.placeholder,
					width: action.data
				}
			}
		case FORM_TEMPLATE_ITEM_COPY:
			return {
				...state,
				formItemCopy: action.data
			}
		case FORM_EDIT_CHANGE:
			return {
				...state,
				disable: action.disabled
			}
		case FORM_EDITED:
			return {
				...state,
				formEdited: action.edited
			}
		case LOAD:
			return {
				...state,
				load: action.load
			}
		case RESET_FORM_STORE:
			return initState
		case RESET_STORE:
			return initState
		default:
			return state
	}
}
